module.exports = __webpack_public_path__ + "static/media/easynote2.ea0ed867.png";